import React, { useEffect, useState } from "react";
import Navbar from "../../components/header/Header";
import { TabView, TabPanel } from "primereact/tabview";
import "./AllProjects.scss";
import MapWrapper from "./Map";
import Info from "./Info";
import Event from "./Event";
import Visualization from "./Visualiztion";
import ProjectService from "./ProjectService";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import Alarms from "./Alarms";

const AllProjects = () => {
  const { t } = useTranslation();

  let location = useLocation();
  const { projectId } = useParams<any>();

  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [visualizationData, setVisualizationData] = useState<any>();
  const [userDetails, setUserDetails] = useState<any>([]);

  const projectService = new ProjectService();

  const openVisualization = () => {
    setActiveIndex(4);
  };

  const [cordinates, setCordinates] = useState<any>([]);

  useEffect(() => {
    setTimeout(function () {
      i18n.changeLanguage(localStorage.getItem("lang")!);
    }, 1000);
    if(localStorage.getItem('tabVal') === 'events')
      setActiveIndex(3);
    else
      setActiveIndex(0);
    projectService.getUserDetails().then((response) => {
      setUserDetails(response);
      if (projectId === undefined) {
        projectService
          .getCoordinates(response["id"], projectId)
          .then((response) => {
            setCordinates(response);
          });
      } else {
        projectService
          .getCoordinates(response["id"], projectId)
          .then((response) => {
            setCordinates(response);
          });
      }
    });
  }, [location.pathname, i18n.language]);
  return (
    <>
      <Navbar userDetails={userDetails} />
      <div className="grid mt-3">
        <div className="col-12 project">
          <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => {
              if(e.index === 0){
                localStorage.removeItem("eventSelect");
                localStorage.removeItem("eventsList");
                localStorage.removeItem("eventStrtTime");
                localStorage.removeItem("eventEndTime");
              }
              setActiveIndex(e.index)
            }}
          >
            <TabPanel header={t("information")} leftIcon="pi pi-info" >
              <Info switchTab={()=>{ setActiveIndex(3);}} />
            </TabPanel>
            <TabPanel header={t("warnings")} leftIcon="pi pi-bell">
              <Alarms />
            </TabPanel>
            <TabPanel header={t("map")} leftIcon="pi pi-map">
              <MapWrapper data={cordinates} />
            </TabPanel>
            <TabPanel header={t("events")} leftIcon="pi pi-calendar-times">
              <Event
                userDetails={userDetails}
                openVisualization={(rowData: any) => {
                  setVisualizationData(rowData);
                  openVisualization();
                }}
              />
            </TabPanel>

            <TabPanel
              header={t("visualization")}
              leftIcon="pi pi-chart-line"
              disabled
            >
              <Visualization data={visualizationData} />
            </TabPanel>
          </TabView>
        </div>
      </div>
    </>
  );
};

export default AllProjects;
